(function () {
  const sidePanel = document.createElement('div')
  sidePanel.classList.add('side-panel-wrapper');

  const pageWrapper = document.querySelector('#wrapper');
  if (sidePanel && pageWrapper) {
    pageWrapper.appendChild(sidePanel);
  }

  const storeAvailability = document.querySelector('.store-availability');
  if (!storeAvailability) return;

  const getPickupLocations = async () => {
    const domainName = 'https://netlify.blacklemon.dk'
    const storeName = 'plaza-ure-smykker'
    const metafieldKey = 'available_for_local_pickup'
    const namespace = 'custom'
    const APIURL = `${domainName}/.netlify/functions/getStoresByMetafield?store=${storeName}&metafieldKey=${metafieldKey}&namespace=${namespace}`
    let response = null
    try {
      response = await fetch(APIURL)
    } catch (error) {
      console.log('There was an error', error)
    }
    if (response?.ok) return await response.json()
  }

  document.addEventListener('DOMContentLoaded', async () => {
    const pickupLocations = await getPickupLocations();
    initStoreAvailability(pickupLocations);
  })

  function initStoreAvailability(pickupLocations) {
    const bundleProductsVariantIDs = storeAvailability.dataset.bundleProductVariantIds.split(',');
    const bundleProductIDs = document.querySelector('.store-availability')?.dataset?.bundleProductIds?.split(',');

    const variantID = document.querySelector('.product-information').dataset.variant_id;
    const inventoryNoticeThreshold = storeAvailability.dataset.inventoryNoticeThreshold;
    const showInventoryNotice = storeAvailability.dataset.showInventoryNotice;
    const sidePanel = storeAvailability.querySelector('.side-panel');
    const openSidePanel = storeAvailability.querySelector('[open-side-panel]');

    async function productAndVariantsInventoryOnLoad(event) {
      if(bundleProductIDs.length > 1){
        const variantsInventoryLevels = await getBundleVariantInventoryLevels(bundleProductIDs);
        handleBundleInventory(
          variantsInventoryLevels,
          pickupLocations,
          inventoryNoticeThreshold,
          showInventoryNotice,
          bundleProductsVariantIDs
        ) 

        async function getBundleVariantInventoryLevels(bundleProductIDs){
          const bundleSize = bundleProductIDs.length;
          let inventoryData = [];
      
          const promises = bundleProductIDs.map(async (productID) => {
              const data = await getVariantsInventoryLevels(productID);
              return data;
          });
      
          inventoryData = await Promise.all(promises);
          return inventoryData;
        }

        async function getVariantsInventoryLevels(productID) {
          if (!productID) return;
      
          const domainName = 'https://netlify.blacklemon.dk'
          const storeName = 'plaza-ure-smykker'
          const APIURL = `${domainName}/.netlify/functions/getProductInventoryLevels?store=${storeName}&prodId=${productID}`
          try {
            const response = await fetch(APIURL)
            if (response?.ok) return await response.json()
          } catch (error) {
            console.log('There was an error', error)
          }
        }      

      } else {
        handleVariantInventory(
          event,
          pickupLocations,
          inventoryNoticeThreshold,
          showInventoryNotice,
          variantID
        );
      }

      document.removeEventListener('productAndVariantsInventoryOnLoad', productAndVariantsInventoryOnLoad)
    }

    openSidePanel.addEventListener('click', () => triggerSidePanel(true))

    function handleBundleInventory(variantsInventoryLevels, pickupLocations, inventoryNoticeThreshold, showInventoryNotice, bundleProductsVariantIDs) {
      // filter pickup locations based on available variant inventory
      let availablePickupLocations = pickupLocations;
      let bundleSize = variantsInventoryLevels.length;
      for(let i = 0; i < bundleSize; i++){
        let variantInventory = variantsInventoryLevels[i][0]['inventory_quantities'];
        availablePickupLocations = availablePickupLocations
          .filter(location => variantInventory
            .map(variant => variant.name)
            .includes(location.name) && location)
      }

      // filter variant inventory based on available pickup locations
      for(let i = 0; i < bundleSize; i++){
        variantsInventoryLevels[i][0]['inventory_quantities'] = variantsInventoryLevels[i][0]['inventory_quantities']
        .filter(variant => availablePickupLocations
          .map(location => location.name)
          .includes(variant.name))
          variantsInventoryLevels[i][0]['inventory_quantities'] = variantsInventoryLevels[i][0]['inventory_quantities'];
      }

      // gather level of full bundle sets in each available location
      let availableBundleInventory = variantsInventoryLevels[0][0]['inventory_quantities'];
      for(let i = 1; i < bundleSize; i++){
        let variantInventory = variantsInventoryLevels[i][0]['inventory_quantities'];
        for(let i = 0; i < availableBundleInventory.length; i++){
          if(availableBundleInventory[i].level > variantInventory[i].level){
            availableBundleInventory[i].level = variantInventory[i].level;
          }
        }
      }
      const isOnlineExclusive = availableBundleInventory.find(variantLevels => variantLevels.name === "Weblager")?.level || 0;

      availablePickupLocations && renderLocations(availablePickupLocations, availableBundleInventory, inventoryNoticeThreshold, showInventoryNotice, isOnlineExclusive)
      return { availablePickupLocations, availableBundleInventory };
    }

    function handleVariantInventory(event, pickupLocations, inventoryNoticeThreshold, showInventoryNotice, variantID) {
      const { variantsInventoryLevels } = event.detail;
      const { inventory_quantities } = variantsInventoryLevels.find(inventory => inventory.id.includes(variantID));
      const isOnlineExclusive = inventory_quantities.find(variantLevels => variantLevels.name === "Weblager")?.level || 0;

      if (inventory_quantities && pickupLocations) {
        let availableVariantInventory = inventory_quantities.filter((variantInv) => variantInv.level > 0)

        // filter pickup locations based on available variant inventory
        let availablePickupLocations = pickupLocations
          .filter(location => availableVariantInventory
            .map(variant => variant.name)
            .includes(location.name) && location)

        // filter variant inventory based on available pickup locations
        availableVariantInventory = availableVariantInventory
          .filter(variant => availablePickupLocations
            .map(location => location.name)
            .includes(variant.name))
        availableVariantInventory = availableVariantInventory

        availablePickupLocations && renderLocations(availablePickupLocations, availableVariantInventory, inventoryNoticeThreshold, showInventoryNotice, isOnlineExclusive)

        return { availablePickupLocations, availableVariantInventory };
      }
      document.removeEventListener('productAndVariantsInventoryOnLoad', handleVariantInventory)
    }


    function renderLocations(availablePickupLocations, availableVariantInventory, inventoryNoticeThreshold, showInventoryNotice, isOnlineExclusive) {
      if (availablePickupLocations && availablePickupLocations.length) {
        // Remove locations in side panel if any exists
        let locations = document.querySelector('.side-panel-wrapper-template .pickup-locations')
        let firstChild = locations.firstElementChild
        while (firstChild) {
          firstChild.remove()
          firstChild = locations.firstElementChild
        }

        const totalAvailableItems = availableVariantInventory.reduce((acc, curr) => acc + curr.level, 0)

        if (showInventoryNotice === 'low' && totalAvailableItems > inventoryNoticeThreshold) {
          // storeAvailability.classList.add('d-none')
        } else {
          const noticeColor = totalAvailableItems > parseInt(inventoryNoticeThreshold) ? 'normal' : 'low'

          // Update store availability in product page
          storeAvailability.querySelector('.in-stores').classList.remove('d-none');
          storeAvailability.querySelector('.online-exclusive').classList.add('d-none');
          storeAvailability.querySelector('.product-inventory-notice.pp').classList.remove('d-none');

          storeAvailability.querySelector('.product-inventory-notice.pp').classList.remove('product-inventory-notice--normal', 'product-inventory-notice--low')
          storeAvailability.querySelector('.product-inventory-notice.pp').classList.add('product-inventory-notice--' + noticeColor)
          storeAvailability.querySelector('.pickup-availabilities-size').innerText = `${availablePickupLocations.length}`

          // Update pickup locations in side panel popup
          const temp = document.querySelector("template.pickup");
          const itemHtml = temp.content.querySelector(".pickup-location");
          availablePickupLocations.map((location) => {
            const variantLevel = availableVariantInventory.find(vLevel => vLevel.name === location.name).level
            const noticeColor = variantLevel > parseInt(inventoryNoticeThreshold) ? 'normal' : 'low'

            const node = document.importNode(itemHtml, true)

            node.querySelector('.product-inventory-notice').classList.add('product-inventory-notice--' + noticeColor)
            node.querySelector('.location-name').textContent = location.name
            if (location.distance) node.querySelector('.pickup-location__distance').textContent = '(' + location.distance + 'km)'
            node.querySelector('.pickup-location__items').textContent = variantLevel
            node.querySelector('.pickup-location__address .address1').textContent = location?.address?.address1
            node.querySelector('.pickup-location__address .zip').textContent = location?.address?.zip
            node.querySelector('.pickup-location__address .city').textContent = location?.address?.city

            document.querySelector('.side-panel-wrapper-template .pickup-locations').appendChild(node)
          })
        }
      } else if (isOnlineExclusive > 0) {
        // Remove existing information
        storeAvailability.querySelector('.in-stores').classList.add('d-none');
        storeAvailability.querySelector('.online-exclusive').classList.remove('d-none');

        const noticeColor = isOnlineExclusive > parseInt(inventoryNoticeThreshold) ? 'normal' : 'low'
        storeAvailability.querySelector('.product-inventory-notice.pp').classList.remove('product-inventory-notice--normal', 'product-inventory-notice--low')
        storeAvailability.querySelector('.online-exclusive .product-inventory-notice').classList.add('product-inventory-notice--' + noticeColor);
        storeAvailability.querySelector('.product-inventory-notice.pp').classList.remove('d-none');
      } else {
        storeAvailability.querySelector('.in-stores').classList.add('d-none');

        // storeAvailability.querySelector('.product-inventory-notice.pp').classList.add('d-none')
        // storeAvailability.querySelector('.pickup-availabilities-size').innerText = '0'
        // document.querySelector('.side-panel__enable-location').classList.add('d-none')
        // document.querySelector('.pickup-locations').innerText = `${storeAvailability.dataset.localesNoPickup}`
      }

      const sidePanelTemplate = storeAvailability.querySelector('.side-panel-wrapper-template');
      const sidePanel = document.querySelector('.side-panel-wrapper');
      // overwrite side panel with content from updated template
      if (sidePanelTemplate) sidePanel.innerHTML = sidePanelTemplate.innerHTML;

      // Event listeners have to be added after the side panel is rendered
      const closeSidePanelList = document.querySelectorAll('[close-side-panel]')
      closeSidePanelList.forEach((closeElem) => {
        closeElem.addEventListener('click', () => triggerSidePanel(false))
      })

      const enableLocation = document.querySelector('.side-panel-wrapper [enable-location]')

      enableLocation && enableLocation.addEventListener('click', () => sortByLocationInKm(availablePickupLocations, availableVariantInventory, inventoryNoticeThreshold))
    }


    function sortByLocationInKm(availablePickupLocations, availableVariantInventory, inventoryNoticeThreshold) {
      const deg2rad = (deg) => {
        return deg * (Math.PI / 180)
      }

      const round = (value, precision) => {
        var multiplier = Math.pow(10, precision || 0);
        return Math.round(value * multiplier) / multiplier;
      }

      // get user location and render pickup locations sorted by distance
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition((position) => {
          const lat2 = position.coords.latitude
          const lon2 = position.coords.longitude
          const R = 6371 // Radius of the earth in km

          availablePickupLocations = availablePickupLocations.map((location) => {
            const lat1 = location.address.latitude
            const lon1 = location.address.longitude

            const dLat = deg2rad(lat2 - lat1)  // deg2rad below
            const dLon = deg2rad(lon2 - lon1)
            const a =
              Math.sin(dLat / 2) * Math.sin(dLat / 2) +
              Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) *
              Math.sin(dLon / 2) * Math.sin(dLon / 2);
            const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
            const distance = (R * c) // Distance in km

            return {
              address: location.address,
              id: location.id,
              name: location.name,
              distance: round(distance, 1)
            }
          })
          const availablePickupLocationsSorted = availablePickupLocations.sort((a, b) => a.distance - b.distance)
          renderLocationsSorted(availablePickupLocationsSorted, availableVariantInventory, inventoryNoticeThreshold)

        }, (error) => {
          // Handle errors, e.g. user denied location sharing permissions
          console.error("Error getting user location:", error);
        })
      } else {
        console.log("Geolocation is not supported by this browser.")
      }
    }


    function renderLocationsSorted(availablePickupLocationsSorted, availableVariantInventory, inventoryNoticeThreshold) {
      let locations = document.querySelector('.side-panel-wrapper .pickup-locations')
      let firstChild = locations.firstElementChild
      while (firstChild) {
        firstChild.remove()
        firstChild = locations.firstElementChild
      }

      // Update pickup locations in side panel popup
      const temp = document.querySelector("template.pickup");
      const itemHtml = temp.content.querySelector(".pickup-location");
      availablePickupLocationsSorted.map((location) => {
        const variantLevel = availableVariantInventory.find(vLevel => vLevel.name === location.name).level
        const noticeColor = variantLevel > parseInt(inventoryNoticeThreshold) ? 'normal' : 'low'

        const node = document.importNode(itemHtml, true)

        node.querySelector('.product-inventory-notice').classList.add('product-inventory-notice--' + noticeColor)
        node.querySelector('.location-name').textContent = location.name
        if (location.distance) node.querySelector('.pickup-location__distance').textContent = '(' + location.distance + 'km)'
        node.querySelector('.pickup-location__items').textContent = variantLevel
        node.querySelector('.pickup-location__address .address1').textContent = location?.address?.address1
        node.querySelector('.pickup-location__address .zip').textContent = location?.address?.zip
        node.querySelector('.pickup-location__address .city').textContent = location?.address?.city
        locations.appendChild(node)
      })
    }


    function triggerSidePanel(open) {
      const productRecommendations = document.querySelectorAll('product-recommendations');
      const recentlyViewedProducts = document.querySelectorAll('recently-viewed-products');
      const sidePanel = document.querySelector('.side-panel-wrapper .side-panel');

      if (open) {
        sidePanel.classList.add('active')
        document.getElementsByTagName('body')[0]?.classList.add('overflow-hidden')
        document.getElementsByClassName('header-section')[0]?.classList.add('transition-none')
        for (const pr of productRecommendations) {
          pr.classList.add('-z-1', 'position-relative')
        }
        for (const rvp of recentlyViewedProducts) {
          rvp.classList.add('-z-1', 'position-relative')
        }
      } else {
        sidePanel.classList.remove('active')
        document.getElementsByTagName("body")[0]?.classList.remove('overflow-hidden')
        document.getElementsByClassName('header-section')[0]?.classList.remove('transition-none')
        for (const pr of productRecommendations) {
          pr.classList.remove('-z-1', 'position-relative')
        }
        for (const rvp of recentlyViewedProducts) {
          rvp.classList.remove('-z-1', 'position-relative')
        }
      }
    }

    document.addEventListener('productAndVariantsInventoryOnLoad', productAndVariantsInventoryOnLoad);


    document.addEventListener('product:variant-change', function (e) {
      const variantID = e.detail.variant.id;

      document.addEventListener('productOnChange', productOnChange);
      function productOnChange(event) {
        handleVariantInventory(
          event,
          pickupLocations,
          inventoryNoticeThreshold,
          showInventoryNotice,
          variantID
        );
        document.removeEventListener('productOnChange', productOnChange)
      }
    });
  }
})();

